const MONTHLY_THRESHOLD = 1000000;

const getGiving = (monthlyIncome: number) => {
  const giving = monthlyIncome * 0.1;

  return giving;
};

const getDebt = (monthlyIncome: number) => {
  const debt =
    monthlyIncome >= MONTHLY_THRESHOLD
      ? monthlyIncome * 0.12
      : monthlyIncome * 0.24;

  return debt;
};

const getHousing = (monthlyIncome: number) => {
  const housing = monthlyIncome * 0.25;

  return housing;
};

const getFood = (monthlyIncome: number) => {
  const food =
    monthlyIncome >= MONTHLY_THRESHOLD
      ? monthlyIncome * 0.11
      : monthlyIncome * 0.13;

  return food;
};

const getOther = (monthlyIncome: number) => {
  const other = monthlyIncome >= MONTHLY_THRESHOLD ? monthlyIncome * 0.19 : 0;

  return other;
};

const getUtilities = (monthlyIncome: number) => {
  const utilities =
    monthlyIncome >= MONTHLY_THRESHOLD
      ? monthlyIncome * 0.04
      : monthlyIncome * 0.06;

  return utilities;
};

const getTransportation = (monthlyIncome: number) => {
  const transportation =
    monthlyIncome >= MONTHLY_THRESHOLD
      ? monthlyIncome * 0.02
      : monthlyIncome * 0.03;

  return transportation;
};

const getInsuranceAndTaxes = (monthlyIncome: number) => {
  const insuranceAndTaxes =
    monthlyIncome >= MONTHLY_THRESHOLD
      ? monthlyIncome * 0.06
      : monthlyIncome * 0.11;

  return insuranceAndTaxes;
};

const getHouseholdItems = (monthlyIncome: number) => {
  const householdItems = monthlyIncome * 0.01;

  return householdItems;
};

const getPersonalEntertainment = (monthlyIncome: number) => {
  const personalEntertainment =
    monthlyIncome >= MONTHLY_THRESHOLD
      ? monthlyIncome * 0.1
      : monthlyIncome * 0.07;

  return personalEntertainment;
};

export {
  getGiving,
  getDebt,
  getHousing,
  getFood,
  getOther,
  getUtilities,
  getTransportation,
  getInsuranceAndTaxes,
  getHouseholdItems,
  getPersonalEntertainment,
};
